// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"f83c82f0","116":"81d2ba97","121":"04f5490c","148":"d68d7298","231":"8ca340ba","298":"c70352f8","397":"864d9705","458":"65fa964d","531":"9bd5d1db","674":"2a86d57e","717":"3eb031d8","818":"48f26774"}[chunkId] + ".chunk.js";
};